import { render, staticRenderFns } from "./uiShowcaseList.vue?vue&type=template&id=b2e5929a&scoped=true"
import script from "./uiShowcaseList.vue?vue&type=script&lang=js"
export * from "./uiShowcaseList.vue?vue&type=script&lang=js"
import style0 from "./uiShowcaseList.vue?vue&type=style&index=0&id=b2e5929a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2e5929a",
  null
  
)

export default component.exports